export enum PointerType {
  TOUCH,
  STYLUS,
  MOUSE,
  KEY,
  OTHER,
}
